import { render, staticRenderFns } from "./NewApplication.vue?vue&type=template&id=5297dcf4&scoped=true&"
import script from "./NewApplication.vue?vue&type=script&lang=ts&"
export * from "./NewApplication.vue?vue&type=script&lang=ts&"
import style0 from "./NewApplication.vue?vue&type=style&index=0&id=5297dcf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5297dcf4",
  null
  
)

export default component.exports